<div class="camera-calendar-year">
  <div class="camera-calendar-year__header">
    <div class="camera-calendar-year__header-left">
      <h4 class="camera-calendar-year__title">{{ selectedDate() | date: 'yyyy' }}</h4>
    </div>
    <div class="camera-calendar-year__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="camera-calendar-year__wrapper">
    @for (m of months; track m; let i = $index) {
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            fixRate: fixesOfMonths?.[i],
            average: averageOfMonths?.[i],
            label: m,
            index: i,
          }
        "
      ></ng-container>
    }
  </div>
  <div class="camera-calendar-year__legend">
    <div class="camera-calendar-year__legend-max"></div>
    <span>Maximum</span>
    <div class="camera-calendar-year__legend-min"></div>
    <span>Minimum</span>
  </div>
</div>

<ng-template #item let-fixRate="fixRate" let-label="label" let-index="index" let-average="average">
  <span
    class="camera-calendar-year__item"
    [ngClass]="{ active: fixRate.number > 0 }"
    matTooltip="{{ getTooltip(fixRate) }}"
    (click)="onClickItem(index, fixRate.number > 0)"
    [style.--p]="getPercent(average) + '%'"
    >{{ label }}</span
  >
</ng-template>
